import React from 'react'
import logo from '../logo.svg'
import '../App.css'
import TopNavbarMain from '../Components/TopNavbarMain'
import {
  CssBaseline,
  WithStyles,
  Toolbar,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  withStyles,
  Theme,
  createStyles,
  Button,
} from '@material-ui/core'
import MainLayout from '../Layouts/MainLayout'
import Paper from '@material-ui/core/Paper'
import MUIDataTable from 'mui-datatables'
import {
  Badge,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
} from 'reactstrap'
import { CardBody, CardTitle, Col, Card } from 'reactstrap'
import AddIcon from '@material-ui/icons/Add'

import Header from '../Components/Header'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { IPatient } from '../@types/patient'
import firebase from '../Services/firebase'
import withAuthState, { AuthProps } from '../Enhanchers/withAuthState'
import PatientTable from '../Components/PatientTable'

import AsyncSelect from 'react-select/async'
import PatientForm from '../Forms/patientForm'

type Props = WithStyles<typeof styles> & RouteComponentProps & AuthProps

class PatientCreate extends React.Component<Props> {
  render() {
    return (
      <MainLayout>
        {/* Patient Create Header */}

        <Container fluid style={{ marginTop: 30 }}>
          <Row>
            <Col xs='1'>
              <Button
                style={{ backgroundColor: 'transparent', marginTop: 13 }}
                onClick={() => {
                  this.props.history.goBack()
                }}
              >
                <i
                  className='fa fa-arrow-left  ml-5'
                  style={{ fontSize: 20 }}
                />
              </Button>
            </Col>
            <Col xs='11'>
              <h1 className='pl-0'>Create New Patient</h1>
            </Col>
          </Row>

          <Row xs='12'>
            <Col>
              <hr />
            </Col>
          </Row>
        </Container>

        {/* Page content */}

        <section style={{ backgroundColor: '#fff' }}>
          <PatientForm />
        </section>
      </MainLayout>
    )
  }
}
const styles = (theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
    },
    tableRow: {
      '&:hover': {
        borderLeft: '#17A3AB',
        borderLeftWidth: '10',
        borderLeftStyle: 'solid',
        boxShadow: '0 3px 5px 2px rgba(0,0,0,0.1)',
      },
    },
  })
export default withAuthState(withRouter(withStyles(styles)(PatientCreate)))
